import { Dialog } from '@angular/cdk/dialog';
import { TenancyContext } from '@core/tenancy';
import { Directive, inject } from '@angular/core';
import { ApplicationTypeModal } from '@shared/features/multiple-applications/components/application-type-modal/application-type-modal.component';
import { ApplicationTypeModalSource } from '@shared/features/multiple-applications/components/application-type-modal/enums/application-type-modal-source.enum';

@Directive({
  selector: '[appOpenApplicationSelectModal]',
  host: {
    '(click)': 'openModal()',
  },
})
export class OpenApplicationSelectModalDirective {
  private readonly _dialog = inject(Dialog);
  private readonly _tenancy = inject(TenancyContext);

  private readonly _state_geoname_code = this._tenancy.stateCode;

  protected openModal() {
    this._dialog.open(ApplicationTypeModal, {
      data: {
        state_geoname_code: this._state_geoname_code(),
        source: ApplicationTypeModalSource.CLERK,
      },
    });
  }
}
